import { BrowserRouter, Routes, Route } from "react-router-dom"

import { Toaster } from "./components/sonner"
import { ProtectedRoute } from "./components/protected-route"

import Chat from "./pages/chat"
import Home from "./pages/home"
import Login from "./pages/login"
import Layout from "./pages/layout"

function App() {
  return (
    <BrowserRouter>
      <Toaster />
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route
          path="*"
          element={
            <ProtectedRoute>
              <Layout>
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/chat/:uuid" element={<Chat />} />
                </Routes>
              </Layout>
            </ProtectedRoute>
          }
        />
      </Routes>
    </BrowserRouter>
  )
}

export default App
